export enum InputMode {
  EMAIL = 'email',
  NUMERIC = 'numeric',
  TEXT = 'text'
}
